var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('b-alert',{staticClass:"mt-5",attrs:{"show":"","variant":"warning"}},[_vm._v(" Login to access this page ")]),_c('router-link',{attrs:{"to":"login"}},[_c('b-button',{staticClass:"md-raised mt-2 btn-size",attrs:{"variant":"primary"}},[_vm._v(_vm._s(_vm.$t("auth.login"))+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }